import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMessage } from "../../redux";
import "./style.css"

function Wlist() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [addBar, setAddBar] = useState('');
    const [wListData, setwList] = useState([]);

    useEffect(() => {
        const status = sessionStorage.getItem('status');
        if (status !== 'admin') {
            navigate('/error');
            return
        }

        fetchWlist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchWlist = async () => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/wlist/get`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
            return
        }
        setwList(res);
        console.log(res);

    }

    const addEmailToWlist = async () => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/wlist/add`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: addBar })
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 201 && req.status !== 501) {
            alert(res.message)
            return
        }

        if (req.status === 501) alert(`ATTENTION, L'email a bien été ajouté cependant le lien d'inscription n'a pas réussi à être envoyé`)
        else alert(`Email ajouté, un lien d'inscription a bien été envoyé à ${addBar}`);

        setwList([...wListData, { email: addBar, _id: res._id }])
        setAddBar('');
    }

    const editEmailToWlist = async (_id) => {

    }

    const delEmailToWlist = async (_id) => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/wlist/delete/${_id}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            alert(res.message)
            return
        }
        setwList(wListData.filter(e => e._id !== _id));
        alert(`L'email a bien été retirer, ainsi que toutes les éventuels données associé`);
    }

    return (
        <div className="page_wlist">
            <h1>White List</h1>

            <div className="add_bar">
                <input type="text" placeholder="john.doe@exemple.com" value={addBar} onChange={(e) => setAddBar(e.target.value)} />
                <button onClick={() => addEmailToWlist()}>Ajouter à la liste</button>
            </div>

            <ul>
                <li>{wListData.length === 0 && <p className="list_empty">Aucune données</p>}</li>

                {wListData.length !== 0 && wListData.map((e, idx) =>
                    <li key={idx} className="user_email">
                        <p>{e.email}</p>
                        <button><i className="fas fa-trash" onClick={() => delEmailToWlist(e._id)}></i></button>
                        <button><i className="fas fa-edit" onClick={() => editEmailToWlist(e._id)}></i></button>
                    </li>
                )}
            </ul>
        </div>
    )
}

export default Wlist;